<template>
  <div class="d-flex flex-column mb-2">
    <div class="text-md mb-1">
      <div class="text-thicker">
        {{ group.name }}
      </div>
      <div class="text-secondary output-group-path text-sm">
        Path:
        <a
          v-clipboard:copy="group.masterFilePath"
          v-clipboard:success="copySuccess"
          class="text-primary"
        >
          {{ group.masterFilePath || '-' }}
          <GjIcon
            v-if="group.masterFilePath"
            name="Copy"
            size="13"
          />
        </a>
      </div>
    </div>
    <b-table
      ref="table"
      :items="group.outputs"
      :fields="fields"
      show-empty
      responsive
      class="loaded border-default border-b border-r border-l rounded"
    >
      <template #cell(show_details)="row">
        <a
          v-if="row.item.path !== null"
          @click="row.toggleDetails"
        >
          <GjIcon
            :key="row.detailsShowing ? 'ArrowDown' : 'ArrowRight'"
            :name="row.detailsShowing ? 'ArrowDown' : 'ArrowRight'"
            size="15"
          />
        </a>
      </template>
      <template #cell(path)="row">

        <a
          v-if="validateUrl(row.value)"
          v-clipboard:copy="row.value"
          v-clipboard:success="copySuccess"
          class="link"
        >{{ row.value }} <GjIcon
          name="Copy"
          size="13"
        /></a>

        <a v-else>{{ row.value }} </a>
      </template>
      <template #cell(quality)="row">
        <a
          v-if="row.item.path !== null"
          @click="row.toggleDetails"
        >{{
          row.value
        }}</a>
        <span v-else>{{ row.value }}</span>
      </template>
      <template #row-details="row">
        <output-item
          :dir="dir"
          :path="row.item.path"
          :item="findItem(row.item.path)"
        />
      </template>
    </b-table>
  </div>
</template>
<script>
import m3u8ParserHelpers from '@/mixins/m3u8-parser-helpers'
import OutputItem from './OutputItem.vue'

export default {
  name: 'LiveJobsOutputGroup',
  components: { OutputItem },
  mixins: [m3u8ParserHelpers],
  props: {
    group: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      fields: [
        { key: 'show_details', label: '', variant: 'select' },
        'quality',
        'path',
      ],
      item: null,
    }
  },
  computed: {
    dir() {
      if (!this.group.masterFilePath) return ''
      return this.group.masterFilePath
        .split('/')
        .slice(0, -1)
        .join('/')
    },
  },
  created() {
    this.initParsing(this.group.masterFilePath)
  },
  methods: {
    validateUrl(url) {
      /* eslint-disable no-useless-escape */
      const regExp = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/
      return regExp.test(url)
    },
    findItem(url) {
      if (url) {
        const tempArr = url.split('/')
        const name = `${tempArr[tempArr.length - 2]}/${
          tempArr[tempArr.length - 1]
        }`
        return this.parsedManifest.playlists.find(
          element => element.uri === name,
        )
      }
      return ''
    },
    initParsing(url) {
      this.parsing = true
      this.parseFromUrl(url)
        .then(manifest => {
          this.parsedManifest = manifest
          this.parsing = false
        })
        .catch(err => console.log(err))
    },
  },
}
</script>
